export default "__VITE_ASSET__eT7JDcED__"